var map = {
	"./ai-mi-algorithm-svgrepo-com.svg": 627,
	"./bunny-rabbit-svgrepo-com.svg": 22,
	"./education.svg": 428,
	"./interests.svg": 372,
	"./music-note-svgrepo-com.svg": 684,
	"./party-horn-svgrepo-com.svg": 650,
	"./programming-skills.svg": 821,
	"./projects.svg": 51,
	"./work-history.svg": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;